export enum BUY_TYPE {
    TRIAL_CONVERSION = 'trial conversion',
    ADDON = 'add-on',
    DIRECT_BUY = 'direct buy',
}
